// extracted by mini-css-extract-plugin
module.exports = {"root":"i4zM5","isFisrtLine":"_2mhn_","container":"_1FFgM","hauling":"_3kNgk","isFirstHauling":"_1JhA3","isLastHauling":"_2Kxp3"};